/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";

import Inspector from "components/inspector/inspector";
import MediaGallery from "pages/media-library/components/media-gallery/media-gallery";
import { AnyImage } from "api/search-media-image";

interface Props {
  isActive: boolean;
  closeGallery: () => void;
  setSelectedMedia: (images: AnyImage[]) => void;
}

const WatermarkImageInspector: React.FC<Props> = ({ isActive, setSelectedMedia, closeGallery }) => (
  <Inspector
    title={t("settings.breaking-news-defaults.media-gallery-title")}
    onClose={closeGallery}
    isActive={isActive}
    isActionButtonDisabled={true}
    variant="wide">
    {isActive && (
      <MediaGallery
        showSelectMediaProvider={true}
        setSelectedMedia={setSelectedMedia}
        scrollableTarget="inspector-container"
      />
    )}
  </Inspector>
);

export default WatermarkImageInspector;
